module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "default-bg"
  }, [_c('normalBar', {
    attrs: {
      "title": "选择付款方式",
      "path": "/orderManager/1"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "pay-list"
  }, [(_vm.isWXUA) ? _c('li', [_c('div', {
    staticClass: "pay-items"
  }, [_c('span', {
    staticClass: "checkbox-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payTypes),
      expression: "payTypes"
    }],
    staticClass: "input-checkbox",
    attrs: {
      "type": "radio",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.payTypes, "6")
    },
    on: {
      "change": function($event) {
        _vm.payTypes = "6"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-checkbox"
  })]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "pay-items"
  }, [_c('span', {
    staticClass: "checkbox-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payTypes),
      expression: "payTypes"
    }],
    staticClass: "input-checkbox",
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.payTypes, "2")
    },
    on: {
      "change": function($event) {
        _vm.payTypes = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-checkbox"
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-sure",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.payOrder
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-wx"
  }), _vm._v("\n\t\t\t\t\t微信安全支付\n\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "icon-zfb"
  }), _vm._v("\n\t\t\t\t\t支付宝支付\n\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321a8486","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/payTypes.vue
// module id = 561
// module chunks = 1